import axios from "axios";

const service = axios.create({
    // baseURL: 'https://web.api.wzcwlw.com', // url = base url + request url 赛马生产
    // baseURL: 'http://192.168.72.120:8001', // url = base url + request url
    // baseURL: 'http://106.12.165.54:8001', // url = base url + request url
    // baseURL:'http://180.76.240.138:8001',
    // baseURL:'http://120.48.17.182:8001',
    // baseURL:'http://120.48.52.21:8001',
    // baseURL:'//120.48.178.203:8001',//预生产
    // baseURL:'http://180.76.50.115:8001',
    // baseURL: '',
    baseURL: 'https://www.wzcwlw.com', // 宁夏生产
    // baseURL: 'https://ptuat.wzcwlw.com', // 通用uat
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 1000 * 5 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        // if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        //     config.headers['X-Token'] = getToken()
        // }
        // config.data = {
        //     companyId: Constants.id
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        return res
        // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 20000) {
        //     Message({
        //         message: res.message || 'Error',
        //         type: 'error',
        //         duration: 5 * 1000
        //     })
        //
        //     // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //         // to re-login
        //         MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        //             confirmButtonText: 'Re-Login',
        //             cancelButtonText: 'Cancel',
        //             type: 'warning'
        //         }).then(() => {
        //             store.dispatch('user/resetToken').then(() => {
        //                 location.reload()
        //             })
        //         })
        //     }
        //     return Promise.reject(new Error(res.message || 'Error'))
        // } else {
        //     return res
        // }
    },
    error => {
        console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

export default service